module.exports = "/packs/add-icon-cc98fbe88ff9c13855cb3c349ee4b415.svg";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/packs/Shared/assets/images/add-icon.svg
// module id = ./app/javascript/packs/Shared/assets/images/add-icon.svg
// module chunks = 1